import styled from '@emotion/styled/macro'
import { Box } from '@mui/material'
import theme from 'theme'

export const SearchBarWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  padding: 0;
  position: sticky;
  top: 0;
  z-index: 1;

  .search-icon {
    position: absolute;
    left: 12px;
    top: 12px;
    z-index: 1;

    svg {
      path {
        fill: ${theme.colors.checkboxUnchecked};
      }
    }
  }

  .clear-btn {
    position: absolute;
    right: ${theme.spacing.lg}px;
  }

  .search-bar {
    width: 100%;
    height: 40px;
  }

  .MuiOutlinedInput-input {
    border: 1px solid ${theme.colors.checkboxUnchecked};
    border-radius: ${theme.attributes.borderRadius.small};
    background: ${theme.colors.cardFillTertiary};
    height: 40px;
    padding: 0 ${theme.spacing.xLarge}px;
    color: ${theme.colors.devicesSecondaryText};
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.xLarge};
    font-style: normal;
    font-weight: ${theme.typography.fontWeight.normal};
    line-height: 24px;
    letter-spacing: 0.5px;

    &::placeholder {
      color: ${theme.colors.caption};
      opacity: 1;
    }

    &:focus {
      border-color: ${theme.colors.cta};
    }
  }

  fieldset {
    border: none;
  }
`
